import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE = 'https://stake-clone-43.emergent.host';

const META = {
  '/': {
    title: 'XINCITY — Play the Casino. Build Your Crew. Own the City.',
    desc: 'XINCITY is a persistent multiplayer city built around real online casino games. Play slots and live tables, run crew missions, earn Loyalty Coins and own the neon city. 18+ investor prototype.',
  },
  '/city': {
    title: 'The City Map — Explore Xincity Districts | XINCITY',
    desc: 'Explore the districts of Xincity: Downtown, Neon Strip, Old Quarter, The Port and more. Every district hides games, missions and rewards. 18+.',
  },
  '/casino': {
    title: 'Casino Lobby — Slots, Live Tables & Crash Games | XINCITY',
    desc: 'Browse the Xincity casino lobby: neon slots, live blackjack and roulette, crash games and game shows — every spin fuels your city progress. 18+ demo.',
  },
  '/missions': {
    title: 'Crew & Solo Missions | XINCITY',
    desc: 'Take on cinematic crew missions with real players or run solo jobs across Xincity. Earn Loyalty Coins, status and property. 18+.',
  },
  '/missions/loyalty-job': {
    title: 'The Loyalty Job — Crew Mission | XINCITY',
    desc: 'Run The Loyalty Job with your crew: coordinated spins, shared decisions and Loyalty Coin rewards. 18+ demo.',
  },
  '/missions/solo-run': {
    title: 'Solo Run — Single Player Mission | XINCITY',
    desc: 'Run a solo mission through Xincity at your own pace and stack Loyalty Coins. 18+ demo.',
  },
  '/competitions/crew-vs-crew': {
    title: 'Crew VS Crew — Ranked Confrontations | XINCITY',
    desc: 'Two crews, best of five rounds. Ranked crew confrontations powered by trusted casino game events. Live preview with demo data. 18+.',
  },
  '/competitions/territory-wars': {
    title: 'Territory Wars — District Control | XINCITY',
    desc: 'Crews battle for visible control of Xincity districts. Held territory pays daily Loyalty Coins. Live preview with demo data. 18+.',
  },
  '/crew': {
    title: 'Your Crew — The Syndicate | XINCITY',
    desc: 'Manage your crew, chat with members, track victories and plan the next mission in Xincity. 18+.',
  },
  '/profile': {
    title: 'Player Profile & Progression | XINCITY',
    desc: 'Your persistent Xincity identity: level, crew, property, vehicles and mission history — the city remembers everything. 18+.',
  },
  '/shop': {
    title: 'The Shop — Property, Vehicles & Style | XINCITY',
    desc: 'Spend Loyalty Coins on property, vehicles and style in the Xincity shop. Status you can see. 18+ demo.',
  },
  '/safe-play': {
    title: 'Safe Play & Responsible Gambling | XINCITY',
    desc: 'Responsible gambling tools, limits and player protection are built into Xincity from day one. 18+.',
  },
  '/trust': {
    title: 'Trust, KYC & AML Protection | XINCITY',
    desc: 'How Xincity handles KYC, AML monitoring, fraud protection and trusted game events from licensed providers.',
  },
};

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    if (pathname.startsWith('/admin')) {
      document.title = 'XINCITY';
      upsertMeta('name', 'robots', 'noindex, nofollow');
      return;
    }

    let meta = META[pathname];
    if (!meta && pathname.startsWith('/district/')) {
      const slug = pathname.split('/')[2] || '';
      const name = slug.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
      meta = {
        title: `${name} District | XINCITY`,
        desc: `Explore the ${name} district of Xincity — games, missions and rewards in the neon city. 18+.`,
      };
    }
    if (!meta) meta = META['/'];

    const url = BASE + pathname;
    document.title = meta.title;
    upsertMeta('name', 'robots', 'index, follow, max-image-preview:large');
    upsertMeta('name', 'description', meta.desc);
    upsertMeta('property', 'og:title', meta.title);
    upsertMeta('property', 'og:description', meta.desc);
    upsertMeta('property', 'og:url', url);
    upsertMeta('name', 'twitter:title', meta.title);
    upsertMeta('name', 'twitter:description', meta.desc);
    upsertCanonical(url);
  }, [pathname]);

  return null;
}
